import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_USER_PREFERENCE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetUserPreferencesPayload, GetUserPreferencesResult } from '../types/getUserPreferences.types';

export const GET_USER_PREFERENCE_TAG = 'getUserPreferences';

export const getUserPreferences = (builder: BuilderType) =>
  builder.query<GetUserPreferencesResult, GetUserPreferencesPayload>({
    providesTags: [GET_USER_PREFERENCE_TAG],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_USER_PREFERENCE_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetUserPreferencesResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
